import React from "react";
import PropTypes from "prop-types";
import OutlinedLink from "components/views/atoms/OutlinedLink";
import MSLA from "components/views/atoms/OutlinedLinkContent/MSLA";
import GA from "components/utils/GA";

const navigateMsla = (_lbl) => {
  GA.event({
    category: "homepage",
    action: "msla_link",
    label: _lbl,
  });
  window.open(_lbl, '_blank');
}

const OutlinedMSLA = ({ className, LinkLabel }) => {
  const classes = ["OutlinedMSLA"];
  if (className) classes.push(className);

  return (
    <OutlinedLink className={classes.join(" ")} onClick={() => navigateMsla(LinkLabel)}>
      <MSLA />
    </OutlinedLink>
  );
};

OutlinedMSLA.displayName = "OutlinedMSLA";

OutlinedMSLA.propTypes = {
  className: PropTypes.string,
  LinkLabel : PropTypes.string
};

OutlinedMSLA.defaultProps = {
  className: null,
  LinkLabel : ""
};

export default OutlinedMSLA;
